import { Colour, Tile, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { faInbox } from '@fortawesome/pro-solid-svg-icons/faInbox';
import { IssueEntryType } from '../AccountIssuesTypes';

function PendingStorageChargeIssueEntry(props: IssueEntryType) {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Tile
			onClick={() =>
				navigate('./mail/locked-items', {
					state: { folderId: 9, includeFolderAssigned: true },
				})
			}
			title={t('accountIssues.labels.storageCharges')}
			description={t('accountIssues.counts.item', {
				count: props.count,
			})}
			icon={faInbox}
			isHorizontal
			colour={Colour.Alert}
		/>
	);
}

export { PendingStorageChargeIssueEntry };
